export const TIERS = [
  { id: 'queso', label: 'Queso', color: '#92AD53', index: 0 },
  { id: 'scorcho', label: 'Scorcho', color: '#000000', index: 1 },
  { id: 'inferno', label: 'Inferno', color: '#E59A4B', index: 2 },
  { id: 'epic', label: 'Epic', color: '#D4483B', index: 3 },
];
